<template>
  <div class="Suggestor">
    <div class="tags Selected" style="margin-bottom: 0;">
      <span
        v-for="(c, index) in current"
        class="Chosen tag is-light"
        :key="index"
        >{{ c.name }}&nbsp;<span
          class="delete is-small"
          @click="remove(c.id)"
        ></span
      ></span>
    </div>
    <div class="field has-addons has-addons-right">
      <input type="text" class="input" v-model="query" />
      <button v-if="!hide_plus"
        class="button is-small"
        :class="loading ? 'is-loading' : ''"
        @click="add"
        :disabled="!q"
      >
        <i class="fas fa-plus"></i>
      </button>
    </div>
    <div class="Suggestions" v-show="haystack.length > 0 && q">
      <div class="tags">
        <span
          class="Suggestion tag is-light"
          v-for="s in haystack"
          @click="choose(s)"
          :key="s.id"
          >{{ s.name }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { types as t } from "../../store/actions/kv";
import { kvChangeKey } from "../../store/models/_helpers";
import { types as f } from "../../store/actions/flow";
import { flowTypes, FlowItem } from "../../util/flowNotifications";
import { KV_LIST_FRENCH } from "../../store/actions/kv";
import { ie } from "../../store/models/_helpers";

export default {
  name: "KvSuggestorMultiple",
  props: {
    items: {
      required: true
    },
    type: {
      type: String,
      required: true
    },
    hide_plus: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      query: "",
      current: [],
      loading: false,
      haystack: []
    };
  },
  methods: {
    choose(a) {
      this.query = "";
      this.current.push(a);
      this.$emit("update", this.current.map(a => a.id));
    },
    remove(id) {
      this.current = this.current.filter(a => !ie(id, a.id));
      this.$emit("update", this.current);
    },
    async add() {
      this.loading = true;
      const newKv = await this.$store.dispatch(t.ADD_KV, {
        type: this.type,
        name: this.query.trim()
      });
      this.$emit("update", newKv.id);
      this.$root.$emit(kvChangeKey(this.type));
      this.$store.dispatch(
        f.ADD_FLOW_ITEM,
        FlowItem({
          type: flowTypes.F_INFO,
          message: `Vous avez ajouté "${this.query.trim()}" à "${
            KV_LIST_FRENCH[this.type]
          }"`
        })
      );
      this.query = "";
      this.loading = false;
    }
  },
  computed: {
    q() {
      return this.query.trim().toLowerCase();
    }
  },
  async mounted() {
    if (this.items && this.items.length > 0) {
      this.current = await this.$store.dispatch(t.GET_KV_STACK, {
        type: this.type,
        ids: this.items
      });
    }
  },
  watch: {
    async q(val) {
      if (!val) {
        this.haystack = [];
        return;
      }
      this.haystack = await this.$store.dispatch(t.SEARCH_KV, {
        type: this.type,
        query: val
      });
    },
    async items(val) {
      if (val && val.length > 0)
        this.current = await this.$store.dispatch(t.GET_KV_STACK, {
          type: this.type,
          ids: val
        });
    }
  }
};
</script>
